const gridTitles = {
    YourSearch: 'Your Search',
    Alerts: 'Alerts',
    Subscriptions: 'Subscriptions',
    OtherTeamsAlerts: 'Other Team\'s Alerts',
    MyTeamsAlerts: 'My Team\'s Alerts'
}

const gridFilterTypes = {
    AlertType: 'AlertType',
    Agent: 'Agent',
    TeamLead: 'TeamLead'
}

const myTeamOptions = {
    // TODO: deactivated because we are loosing the grouping in every request to the server.
    // grouping: !(selectedTeam == null || selectedTeam.name === MY_TEAM),
    defaultExpanded: true,
    filtering: false,
    actionsColumnIndex: 0,
    actionsCellStyle: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        letterSpacing: '0px'
    },
    showFirstLastPageButtons: false
}

const otherTeamsOptions = {
    // TODO: deactivated because we are loosing the grouping in every request to the server.
    // grouping: true,
    defaultExpanded: true,
    filtering: false,
    actionsColumnIndex: 0,
    actionsCellStyle: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    showFirstLastPageButtons: false
}

const localization = {
    header: {
        actions: 'Actions',
    },
    body: {
        emptyDataSourceMessage: 'Filter or Search to view Alerts',
    },
}

const filterHeaderToFieldMapping = {
    [gridFilterTypes.Agent]: 'EmployeeData',
    [gridFilterTypes.AlertType]: 'AlertTypeDesc',
    [gridFilterTypes.TeamLead]: 'SupervisorEmployeeData'
}

const transactionMessages = {
    subcription: 'subcription',
    subcribeFailed: 'Subscribe failed',
    unsubcription: 'unsubcription',
    unsubcribeFailed: 'Unsubscribe failed',
    CPPSNotFound: 'CPPSNotFound'
}

const tooltipMessages = {
    subscribeCPPS: 'Subscribe to receive alerts for this CPPS combination',
    subscribeTL: 'Subscribe to receive alerts for the agents of this team lead'
}

const switchOptions = {
    leftTitle: 'Schedule',
    rightTitle: 'Performance',
}

const modalOptions = {
    title: 'Confirm Action',
    description: 'Do you want to unsubscribe from this alert? All historical records will be removed as well',
}

const refreshFrequency = 30000;
const refreshFrequencySeconds = refreshFrequency / 1000;

const performanceAlertType = [
    'ACW',
    'ACWIN',
    'ACWOUT',
    'ADMIN',
    'AUX1',
    'AUX2',
    'AUX3',
    'AUX4',
    'AUX5',
    'AUX6',
    'AUX7',
    'AUX8',
    'AUX9',
    'AUXIN',
    'AUXIN1',
    'AUXIN2',
    'AUXIN3',
    'AUXIN4',
    'AUXIN5',
    'AUXIN6',
    'AUXIN7',
    'AUXIN8',
    'AUXIN9',
    'AUXOUT',
    'AUXOUT1',
    'AUXOUT2',
    'AUXOUT3',
    'AUXOUT4',
    'AUXOUT5',
    'AUXOUT6',
    'AUXOUT7',
    'AUXOUT8',
    'AUXOUT9',
    'AUXWK',
    'AVAIL',
    'BREAK',
    'BUSYIN',
    'COACHING',
    'DEFAULT',
    'HOLD',
    'IN1',
    'IP_Failure',
    'LUNCH',
    'OTHER',
    'OUT1',
    'PERSONAL',
    'PRESHIFT',
    'PROJECT',
    'RING',
    'RONA',
    'SUPERVISOR MODE',
    'SYSTEM',
    'TRAINING',
    'UNAVAIL'
];

const scheduleAlertType = ['BSL', 'SIU', 'SOU', 'WOX', 'EBL'];

export { 
    gridTitles
    , myTeamOptions
    , otherTeamsOptions
    , localization
    , filterHeaderToFieldMapping
    , transactionMessages
    , tooltipMessages
    , switchOptions
    , gridFilterTypes
    , refreshFrequency
    , refreshFrequencySeconds
    , modalOptions
    , performanceAlertType
    , scheduleAlertType
}
